export const GLOBAL_URL_FILTER_ID = "all";

export const EMPTY_CSV_ERROR = "empty_csv_error";
export const NOT_SUPPORTED_HTML5_ERROR = "not_supported_html5";
export const UPLOAD_VALID_CSV_ERROR = "upload_valid_csv";
